module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.image) ? _c('div', {
    staticClass: "i-dragger-cover",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade-in"
    }
  }, [(_vm.image.status === 'uploading') ? _c('i-progress', {
    staticClass: "i-dragger-cover-progress",
    attrs: {
      "percentage": _vm.image.percentage,
      "show-text": false,
      "status": _vm.image.status === 'finished' ? 'success' : ''
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.image.status === 'finished') ? _c('div', {
    staticClass: "i-dragger-cover-content",
    on: {
      "mouseenter": function($event) {
        _vm.mouseover = true
      },
      "mouseleave": function($event) {
        _vm.mouseover = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.image.url
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mouseover),
      expression: "mouseover"
    }],
    staticClass: "i-dragger-cover-interact"
  }, [_c('div', {
    staticClass: "i-draggeer-cover-btns"
  }, [_c('span', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.$parent.handleClick()
      }
    }
  }, [_c('i', {
    staticClass: "i-icon-upload2"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('el.upload.continue')))])]), _vm._v(" "), (_vm.previewStatus) ? _c('span', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.onPreview(_vm.image)
      }
    }
  }, [_c('i', {
    staticClass: "i-icon-view"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('el.upload.preview')))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.onRemove(_vm.image)
      }
    }
  }, [_c('i', {
    staticClass: "i-icon-delete2"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('el.upload.delete')))])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "md-fade-top"
    }
  }, [_c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mouseover),
      expression: "mouseover"
    }],
    staticClass: "i-dragger-cover-title"
  }, [_vm._v(_vm._s(_vm.image.name))])])], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-023fa6bb!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/upload/src/cover.vue
// module id = 603
// module chunks = 0